import { useMemo } from 'react';

import { AgChartsReact } from 'ag-charts-react';

import { cn } from 'lib/helpers/utility';

import { mergeChartOptions } from './lib/theme';
import useDevicePixelRatio from './lib/useDevicePixelRatio';

const GLOSS = {
  radial: {
    background:
      'radial-gradient(68% 68% at 36% 26%, rgba(255,255,255,0.58) 0%, rgba(255,255,255,0.12) 34%, rgba(255,255,255,0) 58%)',
    mixBlendMode: 'soft-light'
  },
  linear: {
    background:
      'linear-gradient(179deg, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0.08) 26%, rgba(255,255,255,0) 52%)',
    mixBlendMode: 'soft-light'
  }
};

const glossKindFor = (options) => {
  const types = (options?.series || []).map((s) => s?.type);
  if (types.some((t) => t === 'donut' || t === 'pie')) return 'radial';
  if (types.some((t) => t === 'bar' || t === 'area')) return 'linear';
  return null;
};

const AGChart = ({ options, className, gloss = true, ...rest }) => {
  const mergedOptions = useMemo(() => mergeChartOptions(options), [options]);
  const dpr = useDevicePixelRatio();
  const isFixedSize = options?.width != null && options?.height != null;

  if (isFixedSize) return <AgChartsReact key={dpr} options={mergedOptions} {...rest} />;

  const kind = gloss === false ? null : typeof gloss === 'string' ? gloss : glossKindFor(options);

  return (
    <div className={cn('relative h-full min-h-[inherit] w-full', className)}>
      <div className="absolute inset-0">
        <AgChartsReact key={dpr} options={mergedOptions} {...rest} />
      </div>
      {kind && GLOSS[kind] && (
        <span className="pointer-events-none absolute inset-0" style={GLOSS[kind]} />
      )}
    </div>
  );
};

export default AGChart;
